import React from "react";

import FormControl from "@mui/material/FormControl";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import IconButton from "@mui/material/IconButton";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useIntl } from "react-intl";
import { getServiceTypeLanguageIdByName } from "../../../modules/ticket/ticketConstants";
import { ListItemButton } from "@mui/material";

const ServiceTypeSection = ({
  serviceTypes = [],
  onNext,
  handleSetFieldValue,
}) => {
  const { formatMessage } = useIntl();

  return (
    <Box sx={{ mb: 1 }}>
      {/* step 1 categories */}
      <FormControl component="fieldset" fullWidth>
        <Typography>
          {formatMessage({ id: "ticket.create.select_type" })}
        </Typography>
        <List sx={{ bgcolor: "background.paper", p: 0 }}>
          {serviceTypes.map((service) => {
            const serviceTypeNameTranslated = formatMessage({
              id: getServiceTypeLanguageIdByName(service.name),
            });

            return (
              <ListItemButton
                key={service.id}
                onClick={(ev) => {
                  handleSetFieldValue("serviceType", service.id);
                  onNext(ev);
                }}
                divider
              >
                <ListItemText primary={serviceTypeNameTranslated} />

                <ListItemSecondaryAction>
                  <IconButton
                    aria-label="next"
                    onClick={(ev) => {
                      // prevent parent ListItem from handling this click twice
                      ev.stopPropagation();
                      handleSetFieldValue("serviceType", service.id);
                      onNext(ev);
                    }}
                  >
                    <ChevronRightIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItemButton>
            );
          })}
        </List>
      </FormControl>
    </Box>
  );
};

export default ServiceTypeSection;
